import { translate } from '@washed/i18n';
import { useTier } from '../lib/useTier.js';
import styles from './Hero.module.css';

export interface HeroProps {
  locale: 'fr' | 'en';
}

export function Hero({ locale }: HeroProps) {
  const t = (k: Parameters<typeof translate>[0]) => translate(k, locale);
  const tier = useTier();
  const fr = locale === 'fr';

  return (
    <section className={styles.hero} id="top" data-tier={tier}>
      <picture className={styles.media}>
        <source
          media="(max-width: 700px)"
          srcSet="/photos/hero-portrait-640.webp 640w, /photos/hero-portrait-1024.webp 1024w"
          sizes="100vw"
        />
        <img
          className={styles.img}
          src="/photos/hero-960.webp"
          srcSet="/photos/hero-640.webp 640w, /photos/hero-960.webp 960w, /photos/hero-1600.webp 1600w"
          sizes="100vw"
          alt={t('marketing.hero.photo.alt')}
          fetchPriority="high"
          decoding="async"
          width={1672}
          height={941}
        />
      </picture>

      <div className={styles.scrim} aria-hidden="true" />

      <div className={styles.content}>
        <p className={styles.because}>{fr ? 'Parce que' : 'Because'}</p>
        <h1 className={`${styles.h1} ${styles.in}`}>
          <span className={styles.lines}>
            <span className={styles.line}>
              <span>{fr ? 'Vous avez mieux' : 'You have better'}</span>
            </span>{' '}
            {/* The space keeps "mieux à" two words for screen readers and search;
                each .line is display:block, so it never shows. */}
            <span className={styles.line}>
              <span className={styles.serifIt}>{fr ? 'à faire.' : 'things to do.'}</span>
            </span>
          </span>
        </h1>

        <p className={styles.sub}>{fr ? 'Formules dès 4 500 F CFA' : 'Plans from CFA 4,500'}</p>

        <a href={fr ? '/tarifs' : '/en/tarifs'} className={styles.btn}>
          {fr ? 'Voir les formules' : 'See plans'}
          <span className={styles.arr} aria-hidden="true">
            ↗
          </span>
        </a>
      </div>
    </section>
  );
}
